import React from "react";

const CoreSolutions = () => {
  return (
    <section className="bg-white py-20">
      <div className="max-w-7xl mx-auto px-6">

        {/* Header */}
        <div className="flex items-center justify-between mb-10">
          <h2 className="text-2xl md:text-3xl font-semibold text-[#0F172A]">
            Core solutions
          </h2>

          <div className="flex items-center gap-2 text-xs text-[#64748B] border border-[#E2E8F0] rounded-full px-3 py-1">
            <span>Bank-grade security</span>
          </div>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">

          {/* Card 1 */}
          <SolutionCard
            title="Selective Invoice Financing"
            description="Fund only the invoices you choose. Ideal for project-based businesses or seasonal peaks."
            features={[
              "Finance on-demand",
              "Payouts in 24–48h",
              "Transparent fees",
            ]}
            buttonLabel="Explore selective"
          />

          {/* Card 2 */}
          <SolutionCard
            title="Whole Ledger Program"
            description="Finance most or all receivables for consistent liquidity and stronger working capital."
            features={[
              "Predictable cash flow",
              "Multi-buyer support",
              "Volume-based pricing",
            ]}
            buttonLabel="Explore ledger"
          />

          {/* Card 3 */}
          <SolutionCard
            title="Embedded & API Access"
            description="Integrate financing into your platform or ERP. Automate eligibility, offers, and payouts."
            features={[
              "Webhooks & sandbox",
              "Read-only data",
              "Developer docs",
            ]}
            buttonLabel="Explore API"
          />

        </div>
      </div>
    </section>
  );
};

const SolutionCard = ({ title, description, features, buttonLabel }) => {
  return (
    <div className="border border-[#E2E8F0] rounded-2xl p-6 flex flex-col justify-between hover:shadow-sm transition">

      <div>
        <h3 className="text-sm font-semibold text-[#0F172A] mb-2">
          {title}
        </h3>

        <p className="text-sm text-[#64748B] leading-relaxed mb-4">
          {description}
        </p>

        <ul className="space-y-2 mb-6">
          {features.map((feature, index) => (
            <li
              key={index}
              className="flex items-center gap-2 bg-[#D7F3EF] text-[#0F766E] text-xs font-medium px-3 py-2 rounded-md"
            >
              <span className="w-2 h-2 rounded-full bg-[#0F766E]" />
              {feature}
            </li>
          ))}
        </ul>
      </div>

      <button className="bg-[#00B3A4] text-white text-sm font-semibold py-2.5 rounded-md hover:bg-[#009688] transition">
        {buttonLabel}
      </button>
    </div>
  );
};

export default CoreSolutions;
